var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ChangeDetectorRef } from '@angular/core';
import { ModalDialogComponent } from 'src/app/shared/components/modal-dialog/modal-dialog.component';
import { DateHelper } from 'src/app/shared/utils/date-helper';
import { AccordionDirective } from 'src/app/shared/components/accordion/accordion.directive';
export var AvailabilityType;
(function (AvailabilityType) {
    // from - to
    AvailabilityType["absolut"] = "abs";
    // eg. 1:00
    AvailabilityType["span"] = "span";
})(AvailabilityType || (AvailabilityType = {}));
var BaseReservationComponent = /** @class */ (function () {
    function BaseReservationComponent(storage, fb, building, router, activatedRoute, translate, messages, cdr) {
        this.cdr = cdr;
        this.restoringSessionData = false;
        this.eventsAttached = false;
        this.storage = storage;
        this.fb = fb;
        this.building = building;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.translate = translate;
        this.messages = messages;
        this.currentDate = DateHelper.getCurrentDate();
        this.createForm();
    }
    /**
     * Handle click on search-button
     *
     * @memberof BaseReservationComponent
     */
    BaseReservationComponent.prototype.onSearchClick = function () {
        this.executeSearch();
    };
    /**
     * Handle click on date navigation button
     *
     * @param {boolean} backwards
     * @memberof BaseReservationComponent
     */
    BaseReservationComponent.prototype.onNavigateDate = function (backwards) {
        var newDate = DateHelper.parseIsoDateString(this.searchForm.getValue('date'));
        newDate.setDate(newDate.getDate() + (backwards ? -1 : 1));
        this.searchForm.patchValue('date', newDate);
        this.executeSearch();
    };
    /**
     * spans a date time by the amounts of minutes given,
     * without exceeding a deadline if the is one given
     * @param startDate
     * @param spanInMin
     * @param deadline
     */
    BaseReservationComponent.prototype.spanTimeByMinutes = function (startDate, spanInMin, deadline) {
        var d = new Date(startDate);
        d.setHours(startDate.getHours());
        d.setMinutes(startDate.getMinutes() + spanInMin);
        return deadline && d > deadline ? deadline : d;
    };
    /**
     * Open dialog to create a new reservation
     *
     * @param {ICreateReservationParams} params
     * @memberof RoomReservationComponent
     */
    BaseReservationComponent.prototype.onCreateReservation = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // set the end time 15 minutes from now, instead of using end time of the slot
                // TODO: use a configuration instead of hard coded 15 minutes
                params.to = this.spanTimeByMinutes(params.from, 15, params.to);
                this.createReservationParams = params;
                // add info from search-form
                if (!!this.searchForm.getValue('showAvailable')) {
                    this.adjustReservationParams(this.createReservationParams);
                }
                this.createReservationDialog.openModal();
                return [2 /*return*/];
            });
        });
    };
    /**
     * Handle save of reservation
     *
     * @param {string} location
     * @memberof RoomReservationComponent
     */
    BaseReservationComponent.prototype.onReservationSaved = function (location) {
        // close create
        this.createReservationDialog.closeModal(null);
        this.onAfterReservationSaved(location);
    };
    /**
     * Calculate desired start and end date according to selection in form
     *
     * @private
     * @param {Date} startDate
     * @memberof RoomReservationComponent
     */
    BaseReservationComponent.prototype.adjustReservationParams = function (params) {
        var type = this.searchForm.getValue('showAvailableType');
        if (type === AvailabilityType.absolut) {
            var from = Number(this.searchForm.getValue('showAvailableTimeFrom'));
            var to = Number(this.searchForm.getValue('showAvailableTimeTo'));
            DateHelper.setTimeFromMinutesOfDay(from, params.from);
            DateHelper.setTimeFromMinutesOfDay(to, params.to);
        }
        else {
            var minutes = Number(this.searchForm.getValue('showAvailableHours'));
            params.to = new Date(params.from);
            params.to.setMinutes(params.from.getMinutes() + minutes);
        }
    };
    /**
     * Attach events hook
     *
     * @protected
     * @memberof BaseReservationComponent
     */
    BaseReservationComponent.prototype.onAttachEvents = function () { };
    /**
     * Attach events to form etc.
     *
     * @protected
     * @memberof BaseReservationComponent
     */
    BaseReservationComponent.prototype.attachEvents = function () {
        if (!this.eventsAttached) {
            this.eventsAttached = true;
            this.onAttachEvents();
        }
    };
    /**
     * After session data restore hook
     *
     * @protected
     * @memberof BaseReservationComponent
     */
    BaseReservationComponent.prototype.OnAfterRestoreSessionData = function () {
    };
    /**
     * Load session search-form settings from sessionStorage
     *
     * @protected
     * @memberof BaseReservationComponent
     */
    BaseReservationComponent.prototype.restoreSessionData = function () {
        var sessionSettings = this.storage.sessionSettings.getValue();
        var value = sessionSettings[this.getSessionSettingsKey()];
        if (value) {
            try {
                this.restoringSessionData = true;
                this.searchForm.formGroup.patchValue(value);
                this.OnAfterRestoreSessionData();
            }
            finally {
                this.restoringSessionData = false;
            }
        }
    };
    /**
     * Save current search-form to sessionStorage
     *
     * @protected
     * @memberof BaseReservationComponent
     */
    BaseReservationComponent.prototype.updateSessionData = function () {
        var _this = this;
        this.storage.updateSessionSettings(function (currentSettings) {
            if (!_this.restoringSessionData) { // do not save on running restore
                currentSettings[_this.getSessionSettingsKey()] = _this.searchForm.formGroup.value;
            }
        });
    };
    return BaseReservationComponent;
}());
export { BaseReservationComponent };
